const FINANCIAL_NEWS = {
  title: 'Financial News',
  value: 'fnlondon',
  gams: true,
  defaultGroups: ['Dynamic Insets'],
  sizes: [
    {
      id: 'print-fnlondon',
      label: 'Print',
      columns: 4,
      width: 276,
      lines: 20,
      height: 180,
      minColumns: 1,
      maxColumns: 10,
      minWidth: 276,
      maxWidth: 708,
      minLines: 10,
      maxLines: 312,
      minHeight: 180,
      maxHeight: 3120,
      interactive: false,
      scale: 1,
      target: 'fnlondon',
      publish: 'print',
      group: 'Print',
    },
    {
      id: 'fn4u',
      label: 'Financial News 4U',
      width: 300,
      height: 200,
      minWidth: 0,
      minHeight: 200,
      maxHeight: 3000,
      interactive: true,
      scale: 2,
      target: 'fnlondon',
      publish: 'inset',
      group: 'Dynamic Insets',
    },
    {
      id: 'fn8u',
      label: 'Financial News 8U',
      width: 624,
      height: 416,
      minWidth: 468,
      minHeight: 306,
      maxHeight: 3000,
      interactive: true,
      scale: 1,
      target: 'fnlondon',
      publish: 'inset',
      group: 'Dynamic Insets',
    },
    {
      id: 'fn12u',
      label: 'Financial News 12U',
      width: 948,
      height: 632,
      minWidth: 800,
      minHeight: 416,
      maxHeight: 3000,
      interactive: true,
      scale: 1,
      target: 'fnlondon',
      publish: 'inset',
      group: 'Dynamic Insets',
    },
    {
      id: 'fn16u',
      label: 'Financial News 16U',
      width: 1272,
      height: 848,
      minWidth: 800,
      minHeight: 416,
      maxHeight: 3000,
      interactive: true,
      scale: 1,
      target: 'fnlondon',
      publish: 'inset',
      group: 'Dynamic Insets',
    },
    {
      id: 'thumb-fn',
      label: 'Financial News Thumb',
      width: 138,
      height: 92,
      interactive: false,
      scale: 1,
      target: 'fnlondon',
      publish: 'image',
      group: 'Images',
    },
  ],
};

export const FALLBACK_SIZE = 'fn4u';

export const STYLES =
  '\n@import url("https://fonts.wsj.net/PublicoMedium.css");\n@import url("https://s3.amazonaws.com/fonts.wsj.net/Theinhardt.css");';

export default FINANCIAL_NEWS;
